import { render, staticRenderFns } from "./exchange.vue?vue&type=template&id=82ab6df6&scoped=true&"
import script from "./exchange.vue?vue&type=script&lang=js&"
export * from "./exchange.vue?vue&type=script&lang=js&"
import style0 from "./exchange.vue?vue&type=style&index=0&id=82ab6df6&prod&lang=css&"
import style1 from "./exchange.vue?vue&type=style&index=1&id=82ab6df6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ab6df6",
  null
  
)

export default component.exports